import type { PublicUser } from '@/types/domain';
import {
  getBlankBackGroundImage,
  getBlankUserIcon,
} from '@/utils/GetBlankString';
import ImageUrlConvert from '@/utils/ImageUrlConvert';

export const getUserIconImageUrl = (user: PublicUser) => {
  if (!user.icon) {
    return getBlankUserIcon();
  }
  return ImageUrlConvert(user.icon.file_name, true);
};
export const getUserBackGroundImageUrl = (user: PublicUser) => {
  if (!user.backgound_icon) {
    return getBlankBackGroundImage();
  }
  return ImageUrlConvert(user.backgound_icon.file_name, true);
};
